import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './styles/index.css';
import './styles/platform-specific.css';
import { resetStorageFlags } from './utils/reset-firebase-flags';
import './utils/clear-firebase-flags'; // This will run immediately
import './i18n'; // Initialize i18n
import logger from './utils/logger';
// Removed fresh install detection - auth state now handled by Firebase naturally

// Reset any stale localStorage flags to ensure consistent Firebase behavior
resetStorageFlags();

// Set up global error handlers for crash recovery
if (typeof window !== 'undefined') {
  // Handle unhandled errors
  window.addEventListener('error', async (event) => {
    // Skip logging null/undefined errors to reduce noise
    if (event.error != null) {
      logger.error('Global error caught:', event.error);
      if (event.error?.message?.includes('Firebase') || 
          event.error?.message?.includes('permission') ||
          event.error?.message?.includes('auth')) {
        // Previously handled by crash recovery system - now simplified
      }
    }
  });
  
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', async (event) => {
    // Skip logging null/undefined rejections to reduce noise
    if (event.reason != null) {
      logger.error('Unhandled rejection:', event.reason);
      if (event.reason?.message?.includes('Firebase') || 
          event.reason?.message?.includes('permission') ||
          event.reason?.message?.includes('auth') ||
          event.reason?.code === 'PERMISSION_DENIED') {
        // Previously handled by crash recovery system - now simplified
      }
    }
  });
}

// Create root and render app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Remove StrictMode in development to prevent double rendering
// In production, StrictMode has no effect
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);